import { render } from "./EducationalSectionsList.vue?vue&type=template&id=1c7fac9d&scoped=true"
import script from "./EducationalSectionsList.vue?vue&type=script&lang=js"
export * from "./EducationalSectionsList.vue?vue&type=script&lang=js"

import "./EducationalSectionsList.vue?vue&type=style&index=0&id=1c7fac9d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7fac9d"]])

export default __exports__